import { getLocalizedValue } from "../../../functions/getLocalizedValue";
import { PictureCategory } from "../objects/picture";

export function getPictureCategoryLabel(
    locale: number,
    category: number | PictureCategory | null | undefined,
    categories?: PictureCategory[]
): string | null {
    if (category === null || category === undefined) {
        return null;
    }

    const resolved = typeof category === 'number' ?
        (categories ?? []).find((item) => item.id === category) :
        category;

    if (resolved === undefined) {
        return null;
    }

    const label = getLocalizedValue(
        Number(locale),
        {localization: resolved.localization ?? []},
        'name',
        resolved.name ?? undefined
    ) as string | undefined;

    return label || resolved.name || null;
}
